import { NgModule }                  from '@angular/core';
import { CommonModule }              from '@angular/common';
import { RouterModule }              from '@angular/router';
import { CsChatModule }              from '@cs/components/chat';
import { AiAnalystBubbleComponent }  from './ai-analyst-bubble.component';

/**
 * The global floating chat bubble. Imported eagerly by the PM shell so the launcher is present on
 * every authenticated page; the full-page deep-dive lives in the separately (lazily) routed
 * {@link AiAnalystModule}.
 */
@NgModule({
	declarations: [AiAnalystBubbleComponent],
	imports:      [CommonModule, RouterModule, CsChatModule],
	exports:      [AiAnalystBubbleComponent]
})
export class AiAnalystBubbleModule {
}
